// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1fVOM","inputDescription":"styles_inputDescription__3F4Gw"};